import * as React from 'react';
import * as Yup from 'yup';
import { FormikProps, FormikActions, Formik } from 'formik';
import Component from '@reach/component-component';

import { IFormikOuterProps } from 'src/views/Admin/types';
import { IProfile, IFormProps, IFormState } from '../types';

import {
  parameterize,
  deparameterize,
} from 'src/views/Admin/services/objectHelpers';
import EditForm from './EditForm';

export default class Form extends React.Component<IFormProps, IFormState> {
  id = this.props.id;

  state: IFormState = {
    error: '',
  };

  schema = Yup.object().shape(
    parameterize(this.id, {
      name: Yup.string().required('Name is required.'),
    })
  );

  initialValues = parameterize(this.id, this.props.initialValues) as IProfile;

  onSubmit = async (values: IProfile, actions: FormikActions<IProfile>) => {
    this.setState({ error: '' });
    this.props.preventClosing(false);
    try {
      await this.props.onSubmit(deparameterize(values) as IProfile);
    } catch (error) {
      // todo
      if (error.response.data.errorMessage === 'user_already_exists') {
        this.setState({ error: 'User already exists.' });
      }
    }
    actions.setSubmitting(false);
  };

  updateDirty = ({
    prevProps,
    props,
  }: {
    prevProps: IFormikOuterProps;
    props: IFormikOuterProps;
  }) => {
    if (prevProps.dirty !== props.dirty) {
      this.props.preventClosing(props.dirty);
    }
  };

  formRender = (props: FormikProps<IProfile>) => {
    return (
      <EditForm
        error={this.state.error}
        id={this.props.id}
        allItems={this.props.allItems}
        {...props}
      >
        <Component dirty={props.dirty} didUpdate={this.updateDirty} />
      </EditForm>
    );
  };

  render() {
    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.initialValues}
        validationSchema={this.schema}
        onSubmit={this.onSubmit}
        render={this.formRender}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Profiles/components/Form.tsx